import { actionTypes } from '../actioncreators/actioncreators'

let initialState = {
  text: '',
  show: false
}

export const NotesReducer = (currentState = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_NOTE:
      return {
        ...currentState,
        text: action.text
      }
    case actionTypes.LOAD_EXAMPLE_MAP:
      return {
        ...currentState,
        ...action.data.notes,
        show: action.data.notes && action.data.notes.text !== ''
      }
    case actionTypes.TOGGLE_NOTES:
      return {
        ...currentState,
        show: !currentState.show
      }
    default:
      return currentState
  }
}

export default NotesReducer
